module.exports = __webpack_public_path__ + "assets/img/bg-line-mecha-77fc4a33.png";